<template>
  <div id="resultReport" class="page">
    <div class="header">
      <div class="header-title" id="header_title">{{$t('T_REPORT_TITLE')}}</div>
      <div class="header-logo"></div>
    </div>
    <div class="container" :class="{'simple_container' : isSimple}">
      <div class="content-top">
        <div class="top-img">
          <img :src="pjImgUrl" width="200px" height="200px">
        </div>
        <div class="top-title">{{selectedModelData.name}}</div>
        <table class="top-table">
          <tr>
            <td v-for="(item, index) in reportTopTableInfo" :key='index'>
              <div class="td-val">{{item.value}}</div>
              <span class="td-val" v-if="item.title === 'T_INFO_BRIGHTNESS'">{{ $t('T_LUMEN') }}</span>
              <div class="td-title" :title="$t(item.title)" :class="{'throw-ratio-item':item.title==='T_THROW_RATIO' && isLongThrowRatioTitle}">{{$t(item.title)}}</div>
            </td>
          </tr>
        </table>
      </div>
      <div class="content-info">
        <div class="info-title">
          {{$t('T_RESULT_THROW_DISTANCE_INFORMATION')}}
        </div>
        <div class="info-item" :class="{'simple-pj-position-item': isSimple}">
          <infoListPanel :arrayData="projectorPosition"></infoListPanel>
        </div>
        <div class="info-item" :class="{'simple-pj-setting-item': isSimple}">
          <infoListPanel :setFlag="true" :arrayData="projectorSetting"></infoListPanel>
        </div>
      </div>
      <div class="content-table" v-if="isUSTWall">
        <div id="USTview-copy"></div>
        <div class="ust-comment">
          <div class="ust-comment-title">{{$t('T_COMMENT')}}</div>
          <CommentArea :isUSTWall=true ></CommentArea>
        </div>
      </div>
      <div class="simple-container" v-else-if="isSimple">
        <div id="Simpleview-copy"></div>
        <div class="ust-comment">
          <div class="ust-comment-title">{{$t('T_COMMENT')}}</div>
          <CommentArea :isSimple=true></CommentArea>
        </div>
      </div>
      <div class="content-table" v-else>
        <div class="content-table-item" v-for="(item, index) in canvasArray" :key="index">
          <div>{{$t(item.title)}}</div>
          <canvas width="400" height="400" :id="item.sourceId + '-copy'"></canvas>
        </div>
        <div class="content-table-item">
          <div>{{$t('T_COMMENT')}}</div>
          <CommentArea class="USTWallFalse" :isTextareaHalf= "curveRadius !== 0 && searchTabActive === 'CurvedSurface'"></CommentArea>
          <div v-if="curveRadius && searchTabActive === 'CurvedSurface'" style="margin-top: 140px;width: 100%;height: 2px; background-color: #e3e3e3;margin-left: -20px;"></div>
          <CurvedResultInformation v-if="curveRadius && searchTabActive === 'CurvedSurface'" :isShowProInfo = false style="margin-top: 150px;"></CurvedResultInformation>
        </div>
      </div>
    </div>
    <div class="pdf_footer">
      <Footer></Footer>
    </div>
    <div class="fullyear_footer">
      {{new Date() | filterDate}}
    </div>
  </div>
</template>

<script>
import infoListPanel from '@/components/infoListPanel'
import USTview from '@/view/graph/UST/USTViewIndex'
import CommentArea from './commentArea'
import Footer from '@/components/footer'
import CurvedResultInformation from '@/view/result/curvedResultInformation'

import { mapState } from 'vuex'
export default {
  name: 'resultReport',
  data () {
    return {
      canvasArray: [{
        sourceId: 'sideView',
        title: 'T_SIDE_VIEW'
      }, {
        sourceId: 'frontView',
        title: 'T_FRONT_VIEW'
      }, {
        sourceId: 'topView',
        title: 'T_TOP_VIEW'
      }]
    }
  },

  props: ['reportTopTableInfo', 'projectorPosition', 'projectorSetting'],

  mounted () {
    this.languageData()
  },

  methods: {
    initCanvas () {
      if (!this.isUSTWall && !this.isSimple) {
        this.canvasArray.forEach((item) => {
          let source = document.getElementById(item.sourceId)
          let target = document.getElementById(item.sourceId + '-copy')
          let context = target.getContext('2d')
          // #27463
          context.clearRect(0, 0, 400, source.height)
          context.drawImage(source, 0, 0, 400, source.height)
        })
      }
    },
    languageData () {
      let headertitle = document.getElementById('header_title')
      if (headertitle !== null) {
        if (this.$i18n.locale === 'es' || this.$i18n.locale === 'sv' || this.$i18n.locale === 'el') {
          headertitle.style.fontSize = '22px'
        } else {
          headertitle.style.fontSize = '25px'
        }
      }
    }
  },

  filters: {
    filterDate (date) {
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return Y + M + D
    }
  },

  computed: {
    ...mapState(['selectedModelData', 'isUSTWall', 'isSimple', 'isOutOfSpec', 'searchTabActive', 'curveRadius']),

    pjImgUrl () {
      let url = this.selectedModelData.url
      return url + '.jpg'
    },
    isLongThrowRatioTitle () {
      return this.$i18n.locale === 'lv' || this.$i18n.locale === 'sk'
    }
  },
  watch: {
    curveRadius (newValue) {
      console.log('newValue', newValue)
      return newValue
    }
  },
  components: {
    infoListPanel,
    USTview,
    CommentArea,
    Footer,
    CurvedResultInformation
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  color: #000;
}

@page {
    size: A4;
    margin: 0;
}

@media print {
    .page {
        margin: 0;
        border: initial;
        border-radius: initial;
        width: initial;
        min-height: initial;
        box-shadow: initial;
        background: initial;
        page-break-after: always;
    }
}

.header {
  width: 100%;
  height: 150px;
  margin-bottom: 20px;
  position: relative;
  padding-top: 52px;
}

.header-title {
  font-size: 25px;
  font-weight: bold;
  position: absolute;
  bottom: 0;
  left: 70px;
}

.header-logo {
    height: 100%;
    background: url('../../assets/parts/report/Tagline_Logo_R.jpg') no-repeat;
    background-size: contain;
    width: 230px;
    height: 100px;
    position: absolute;
    right: 65px;
}

.container {
    height: 1464px;
    border: 1px solid #e3e3e3;
    margin: 0 70px;
}

.content-top {
    height: 25%;
    border: 1px solid #e3e3e3;
    /* border-top: none;
    border-left: none;
    border-right: none; */
    /* border-bottom: 2px solid #e3e3e3; */
}

.content-info {
    height: 19%;
    /* border-bottom: 2px solid #e3e3e3; */
    border: 1px solid #e3e3e3;
}

.content-table {
    height: 56%;
}

.content-table-item {
    width: 50%;
    height: 50%;
    float: left;
    text-align: center;
    position: relative;
    border: 1px solid #e3e3e3;
}

.top-img {
    width: 50%;
    margin: 0 auto;
    height: 210px;
    text-align: center;
    padding-top: 10px;
}

.top-title {
    font-size: 25px;
    text-align: center;
    padding: 15px 0 20px 0;
    font-weight: bold;
}

.top-table {
    height: 12.5%;
    margin: 0 auto;
}

.top-table td{
    height: 12.5%;
    margin: 0 auto;
    padding: 10px 20px;
    text-align: center;
}

.top-table, .top-table td {
    border: 1px solid #e3e3e3;
    border-collapse: collapse;
}

.td-val {
    display: inline-block;
    font-size: 18px;
    font-weight: bold;
}

.td-title {
    font-size: 16px;
    color: #666;
    max-width: 340px;
    height: 20px;
    word-break: break-word;
}
.throw-ratio-item{
  line-height: 14px;
}
.info-title {
    padding: 10px 0 10px 20px;
    font-size: 18px;
    font-weight: bold;
}

.info-item {
    float: left;
    width: 50%;
}

canvas {
    margin: 0 auto;
}
#frontView-copy {
  padding-top: 20px;
}

.content-table-item div {
    position: absolute;
    font-size: 16px;
    font-weight: bold;
    left: 20px;
    top: 20px;
}
.content-table-item .USTWallFalse {
  font-weight: normal;
}
.fullyear_footer {
  margin-top: 85px;
  text-align: right;
  font-weight: bold;
  font-size: 16px;
  margin-right: 30px;
  padding-bottom: 10px;
}
.pdf_footer {
  float: left;
}
.pdf_footer .container-footer {
  background: none;
}
#USTview-copy {
  padding-left: 120px;
  background: #cacaca
}
#Simpleview-copy {
  padding-left: 50px;
  background: #cacaca;
  /* height: 635px; */
}
.ust-comment-title {
  font-size: 16px;
  font-weight: bold;
}
.ust-comment {
  padding: 10px;
}
.simple-pj-position-item {
  width: 55%
}
.simple-pj-setting-item {
  width: 45%
}
</style>



// WEBPACK FOOTER //
// src/view/result/resultReport.vue